<template>
  <div>
    <DelDialog
      width="600px"
      :dialogVisible="visible"
      @handleClose="handleCancel"
      @handleConfirm="handleConfirm"
    >
      <template #title>{{$t('assignTaskV2.divide')}}</template>
      <div class="split-content">
        <div class="split-ul">
          <ul class="split-left">
            <li>{{$t('assignTaskV2.fileName')}}：</li>
            <li>{{$t('assignTaskV2.numberWord')}}：</li>
            <li>{{$t('assignTaskV2.sentenceSegment')}}：</li>
            <li class="split-num">{{$t('assignTaskV2.dismantle')}}：</li>
          </ul>
          <ul class="split-right">
            <li class="file-name">{{selObj.fileName}}</li>
            <li>{{selObj.wordNum}}</li>
            <li>{{sentNum}}</li>
            <li class="split-num">
              <el-input-number
                @change="handleSplit"
                v-model="splitNum"
                controls-position="right"
                :min="2"
                @blur="handleBlur"
                :max="sentNum"
                size="small"
              ></el-input-number>
              <!-- <el-button @click="handleSplit">{{$t('assignTaskV2.apart')}}</el-button> -->
            </li>
            <li>
              <el-radio-group v-model="radio" @change="radioChange">
                <el-radio :label="1">{{$t('assignTaskV2.segmentSentence')}}</el-radio>
                <el-radio :label="0">{{$t('assignTaskV2.segmentNumber')}}</el-radio>
              </el-radio-group>
            </li>
          </ul>
        </div>

        <div class="split-table" v-if="radio === 1 && fileList.length !== 0">
          <el-table
          border
          height="100%"
          :data="fileList"
          header-row-class-name="customHeader"
        >
          <el-table-column :label="$t('assignTaskV2.sequence')" align="center" width="55px">
            <template slot-scope="{ $index }">
              {{ $index + 1 }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('assignTaskV2.numberWord')" width="150" align="center" prop="num">
          </el-table-column>
          <el-table-column :label="$t('assignTaskV2.segmentRange')" min-width="180" align="center">
            <template slot-scope="{ row, $index }">
              <el-input
                v-model="row.sentenceRange.start"
                class="wordNumIpt"
                :disabled="
                  row.sentenceRange.start === selObj.startRow ||
                  sentNum === splitNum
                "
                size="small"
                @change="startChange($index)"
                @focus="startFocus($index)"
              ></el-input
              >~<el-input
                v-model="row.sentenceRange.end"
                class="wordNumIpt"
                :disabled="
                  row.sentenceRange.end === selObj.endRow || sentNum === splitNum
                "
                size="small"
                @change="endChange($index)"
                @focus="endFocus($index)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column :label="$t('assignTaskV2.view')" align="center" class-name="view">
            <template slot-scope="{ row }">
              <el-tooltip effect="dark" :content="$t('assignTaskV2.views')" placement="top">
                <i class="icon-preview" @click="handlePreview(row)"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        </div>

        <div class="split-table" v-if="radio === 0 && fileList.length !== 0">
          <el-table
            border
            height="100%"
            :data="fileList"
            header-row-class-name="customHeader"
          >
            <el-table-column :label="$t('assignTaskV2.sequence')" align="center" width="55px">
              <template slot-scope="{ $index }">
                {{ $index + 1 }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('assignTaskV2.numberWords')" width="150" align="center">
              <template slot-scope="{ row, $index }">
                <el-input
                  v-model="row.num"
                  class="wordNumIpt"
                  @change="numChange($index)"
                  :disabled="sentNum === splitNum"
                  @focus="numFocus($index)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('assignTaskV2.segmentRanges')" min-width="180" align="center">
              <template slot-scope="{ row }">{{ row.sentenceRange.start }}~{{ row.sentenceRange.end }}</template>
            </el-table-column>
            <el-table-column :label="$t('assignTaskV2.oneViews')" align="center" class-name="view">
              <template slot-scope="{ row }">
                <el-tooltip effect="dark" :content="$t('assignTaskV2.twoViews')" placement="bottom">
                  <i class="icon-preview" @click="handlePreview(row)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </DelDialog>
    <Preview
      :visible="innerVisible"
      :previewObj="previewObj"
      @handleCancel="previewCancel"
    >
    </Preview>
  </div>
</template>

<script>
import DelDialog from '@/components/delDialog';
import Preview from '@/components/taskDialog/preview';

import {
  splitTask,
  splitTaskPreView,
  splitTaskPreViewDetail,
} from "@/services/assignTaskApi";

export default {
  name: 'SplitFile',
  components: {
    Preview,
    DelDialog
  },
  props: {
    visible: {
      type: Boolean,
      require: true,
    },
    selObj: {
      type: Object,
      require: true,
    },
  },
  data () {
    return {
      splitNum: 2,
      radio: 1,
      fileList: [],
      focusNum: 0,
      previewObj: {},
      innerVisible: false,
      timeOut: null,
    }
  },
  methods: {
    async handleSplit() {
      this.fileList = [];
      let arr = [];

      if (this.radio === 1) {
        let size = Math.floor(this.sentNum / this.splitNum);
        let num = this.sentNum % this.splitNum;

        if (num !== 0) {
          for (let i = 0; i < this.splitNum; i++) {
            if (arr.length < num) {
              if (arr.length === 0) {
                arr.push({
                  start: this.selObj.startRow,
                  end: this.selObj.startRow + size,
                });
              } else {
                arr.push({
                  start: arr[i - 1].end + 1,
                  end: arr[i - 1].end + size + 1,
                });
              }
            } else if (arr.length < this.splitNum - 1) {
              arr.push({
                start: arr[i - 1].end + 1,
                end: arr[i - 1].end + size,
              });
            } else if (arr.length === this.splitNum - 1) {
              arr.push({
                start: arr[i - 1].end + 1,
                end: this.selObj.endRow,
              });
            }
          }
        } else {
          for (let i = 0; i < this.splitNum; i++) {
            if (arr.length === 0) {
              arr.push({
                start: this.selObj.startRow,
                end: this.selObj.startRow + size - 1,
              });
            } else {
              arr.push({
                start: arr[i - 1].end + 1,
                end: arr[i - 1].end + size,
              });
            }
          }
        }

        let { success, result } = await splitTaskPreView({
          fileId: this.selObj.fileId,
          sentNumbers: arr,
          type: this.radio,
          taskId: this.selObj.selTaskID,
          taskType: this.selObj.taskType
        });

        if (!success) {
          return;
        }

        result.forEach((item) => {
          this.fileList.push({
            num: item.sourceWordNum,
            sentenceRange: {
              start: item.startRow,
              end: item.endRow,
            },
          });
        });

      } else if (this.radio === 0) {
        let size = Math.floor(this.selObj.wordNum / this.splitNum);
        let num = this.selObj.wordNum % this.splitNum;

        if (num !== 0) {
          for (let i = 0; i < this.splitNum; i++) {
            if (arr.length < num) {
              arr.push(size + 1);
            } else {
              arr.push(size);
            }
          }
        } else {
          for (let i = 0; i < this.splitNum; i++) {
            arr.push(size);
          }
        }

        let { success, result } = await splitTaskPreView({
          fileId: this.selObj.fileId,
          wordNumbers: arr,
          type: this.radio,
          taskId: this.selObj.selTaskID,
          taskType: this.selObj.taskType
        });

        if (!success) {
          return;
        }

        result.forEach((item) => {
          this.fileList.push({
            num: item.sourceWordNum,
            sentenceRange: {
              start: item.startRow,
              end: item.endRow,
            },
          });
        });
      }
    },
    async handlePreview(item) {
      this.innerVisible = true;
      let { success, result } = await splitTaskPreViewDetail({
        splitRowsReqVo: {
          end: item.sentenceRange.end,
          start: item.sentenceRange.start,
        },
        fileId: this.selObj.fileId,
      });
      if (!success) {
        return;
      }
      this.previewObj = {
        sentList: result,
      };
    },
    previewCancel () {
      this.innerVisible = false;
    },
    startChange($index) {
      let changeNum = Number(this.fileList[$index].sentenceRange.start);

      if (changeNum < this.focusNum) {
        if (
          changeNum <= this.fileList[$index - 1].sentenceRange.end &&
          changeNum > this.fileList[$index - 1].sentenceRange.start
        ) {
          this.fileList[$index - 1].sentenceRange.end = changeNum - 1;
        } else {
          this.fileList[$index].sentenceRange.start = this.focusNum;
        }
      } else {
        if (changeNum <= this.fileList[$index].sentenceRange.end) {
          this.fileList[$index - 1].sentenceRange.end = changeNum - 1;
        } else {
          this.fileList[$index].sentenceRange.start = this.focusNum;
        }
      }

      let arr = [];
      this.fileList.forEach((item) => {
        arr.push({
          start: Number(item.sentenceRange.start),
          end: Number(item.sentenceRange.end),
        });
      });

      this.timeOut = setTimeout(async () => {
        let { success, result } = await splitTaskPreView({
          fileId: this.selObj.fileId,
          sentNumbers: arr,
          type: this.radio,
          taskId: this.selObj.selTaskID,
          taskType: this.selObj.taskType
        });
        this.timeOut = null;

        if (!success) {
          return;
        }

        this.fileList = [];
        result.forEach((item) => {
          this.fileList.push({
            num: item.sourceWordNum,
            sentenceRange: {
              start: item.startRow,
              end: item.endRow,
            },
          });
        });
      }, 200);
    },
    startFocus($index) {
      this.focusNum = this.fileList[$index].sentenceRange.start;
    },
    endChange($index) {
      let changeNum = Number(this.fileList[$index].sentenceRange.end);

      if (changeNum < this.focusNum) {
        if (changeNum >= this.fileList[$index].sentenceRange.start) {
          this.fileList[$index + 1].sentenceRange.start = changeNum + 1;
        } else {
          this.fileList[$index].sentenceRange.end = this.focusNum;
        }
      } else {
        if (
          changeNum >= this.fileList[$index + 1].sentenceRange.start &&
          changeNum < this.fileList[$index + 1].sentenceRange.end
        ) {
          this.fileList[$index + 1].sentenceRange.start = changeNum + 1;
        } else {
          this.fileList[$index].sentenceRange.end = this.focusNum;
        }
      }

      let arr = [];
      this.fileList.forEach((item) => {
        arr.push({
          start: Number(item.sentenceRange.start),
          end: Number(item.sentenceRange.end),
        });
      });

      this.timeOut = setTimeout(async () => {
        let { success, result } = await splitTaskPreView({
          fileId: this.selObj.fileId,
          sentNumbers: arr,
          type: this.radio,
          taskId: this.selObj.selTaskID,
          taskType: this.selObj.taskType
        });
        this.timeOut = null;

        if (!success) {
          return;
        }

        this.fileList = [];
        result.forEach((item) => {
          this.fileList.push({
            num: item.sourceWordNum,
            sentenceRange: {
              start: item.startRow,
              end: item.endRow,
            },
          });
        });
      }, 200);
    },
    endFocus($index) {
      this.focusNum = this.fileList[$index].sentenceRange.end;
    },
    numChange($index) {
      let changeNum = Number(this.fileList[$index].num);

      if (changeNum > this.selObj.wordNum) {
        this.fileList[$index].num = this.focusNum;
        return;
      }

      if ($index === this.fileList.length - 1) {
        if (
          changeNum < this.focusNum + this.fileList[$index - 1].num &&
          changeNum > 0
        ) {
          if (changeNum < this.focusNum) {
            this.fileList[$index - 1].num += this.focusNum - changeNum;
          } else {
            this.fileList[$index - 1].num -= changeNum - this.focusNum;
          }
        } else {
          this.fileList[$index].num = this.focusNum;
        }
      } else {
        if (
          changeNum < this.focusNum + this.fileList[$index + 1].num &&
          changeNum > 0
        ) {
          if (changeNum < this.focusNum) {
            this.fileList[$index + 1].num += this.focusNum - changeNum;
          } else {
            this.fileList[$index + 1].num -= changeNum - this.focusNum;
          }
        } else {
          this.fileList[$index].num = this.focusNum;
        }
      }

      let arr = [];
      this.fileList.forEach((item) => {
        arr.push(Number(item.num));
      });

      this.timeOut = setTimeout(async () => {
        let { success, result } = await splitTaskPreView({
          fileId: this.selObj.fileId,
          wordNumbers: arr,
          type: this.radio,
          taskId: this.selObj.selTaskID,
          taskType: this.selObj.taskType,
        });
        this.timeOut = null;

        if (!success) {
          return;
        }

        this.fileList = [];
        result.forEach((item) => {
          this.fileList.push({
            num: item.sourceWordNum,
            sentenceRange: {
              start: item.startRow,
              end: item.endRow,
            },
          });
        });
      }, 200);
    },
    numFocus($index) {
      this.focusNum = Number(this.fileList[$index].num);
    },
    splitNumChange () {
      this.fileList = [];
    },
    handleBlur () {
      if (this.splitNum === undefined) {
        this.splitNum = 2;
      }
    },
    handleCancel () {
      this.radio = 1;
      this.fileList = [];
      this.previewObj = {};
      this.splitNum = 2;
      this.$emit('handleCancel');
    },
    async handleConfirm() {
      this.$message.closeAll();
      if (this.fileList.length === 0) {
        this.$message.warning(this.$t('assignTaskV2.needButton'));
        return;
      }

      let arr = [];

      let param = {
        fileId: this.selObj.fileId,
        taskId: this.selObj.selTaskID,
        type: this.radio,
        taskType: this.selObj.taskType
      };

      if (this.radio === 1) {
        this.fileList.forEach((item) => {
          arr.push({
            start: Number(item.sentenceRange.start),
            end: Number(item.sentenceRange.end),
          });
        });
        param.sentNumbers = arr;
      } else {
        let size = Math.floor(this.selObj.wordNum / this.splitNum);
        let num = this.selObj.wordNum % this.splitNum;

        if (num !== 0) {
          for (let i = 0; i < this.splitNum; i++) {
            if (arr.length < num) {
              arr.push(size + 1);
            } else {
              arr.push(size);
            }
          }
        } else {
          for (let i = 0; i < this.splitNum; i++) {
            arr.push(size);
          }
        }
        param.wordNumbers = arr;
      }
      if (this.timeOut) {
        clearTimeout(this.timeOut);
      }
      let { success } = await splitTask(param);

      if (success) {
        this.$message.success(this.$t('assignTaskV2.apartSuccess'));
        console.log(111);
        this.$emit('updateTaskList');
      } else {
        this.$message.warning(this.$t('assignTaskV2.apartFailer'));
      }
      this.handleCancel();
    },
    radioChange () {
      this.previewObj = {};
      this.handleSplit()
    }
  },
  computed: {
    sentNum() {
      return this.selObj.endRow - this.selObj.startRow + 1;
    },
  },
}
</script>

<style lang="less" scoped>
  @import './assets/style.less';
</style>